import { getCurrencyCodeForCountryLabel } from "@/lib/apply-now/hubspot-revenue-mapping";
import { LOCALE_CURRENCY, LOCALE_CURRENCY_SYMBOL } from "@/lib/locale-prefix";

const COUNTRY_CURRENCY: Record<string, string> = {
  Ireland: "€",
  "United Kingdom": "£",
  "United States": "$",
  Australia: "A$",
  Germany: "€",
  Netherlands: "€",
  Spain: "€",
  Belgium: "€",
  Sweden: "kr",
  Denmark: "kr",
  Canada: "C$",
  Other: "$",
};

/**
 * Currency symbol for the revenue input.
 *
 * Country wins once chosen. Before that, the visiting locale is the best
 * available guess — revenue is entered before country, so gating the symbol on
 * the country select left the field unprefixed for the one field that needs it.
 */
export function currencyFor(country: string, locale?: string): string {
  if (country) return COUNTRY_CURRENCY[country] ?? "$";
  return (locale ? LOCALE_CURRENCY_SYMBOL[locale] : undefined) ?? "$";
}

/** Currency code, with the same country-then-locale precedence as {@link currencyFor}. */
export function currencyCodeFor(country: string, locale?: string): string {
  if (country) return getCurrencyCodeForCountryLabel(country);
  return (locale ? LOCALE_CURRENCY[locale] : undefined) ?? "USD";
}
